module.exports = __webpack_public_path__ + "static/media/intro.9fa555ca.mp3";